module.exports = __webpack_public_path__ + "c2e0a1df61caa58dea7b76139730c85b.svg";